// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.tablescroll {
  padding-top: 15px;
}

/* .tables{
  margin: 0px 20px 0px 30px;
} */
.tablescrollunderdiv {
  height: calc(100vh - 115px);
  overflow: auto;
  padding-bottom: 45px;
  margin: 0px 20px 0px 30px;
}

.widthfix {
  width: 100px;
}

.iconsText {
  background-color: transparent;
  color: #666;
  display: flex;
  box-shadow: none;
  height: 20px;
  border: none;
  padding: 0px;
}

.iconsText:hover {
  background-color: transparent;
  box-shadow: none;
}

.linebutton {
  display: flex;
  gap: 20px;
}

.select {
  width: 5px;
}

.circularbg {
  background-color: red;
}

.rectangularbg {
  background-color: blue;
}

/* .table{
  margin-left: 10px;
} */
.searchbox {
  position: relative;
  top: -58px;
  left: -150px;
}

.newTabButton {
  height: 33px;
  width: 78px;
  cursor: pointer;
}

.table_container {
  max-width: calc(100vw - 25px);
  margin: 0 auto;
  max-height: calc(100vh - 120px);
}

.stylecell {
  font-size: 6px;
}

.tabtab {
  max-width: calc(100vw - 25px);
  margin: 0 auto;
  overflow: auto;
  max-height: calc(100vh - 120px);
}

.tabtab::-webkit-scrollbar {
  display: none;
}

.tablerows {
  background-color: blue;
}

.circularbg {
  background-color: brown;
}

.rectangularbg {
  background-color: purple;
}`, "",{"version":3,"sources":["webpack://./components/ServiceList/ServiceList.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;;GAAA;AAGA;EACE,2BAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,6BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAKF;;AAHA;EACE,6BAAA;EACA,gBAAA;AAMF;;AAJA;EACE,aAAA;EACA,SAAA;AAOF;;AALA;EACE,UAAA;AAQF;;AANA;EACE,qBAAA;AASF;;AAPA;EACE,sBAAA;AAUF;;AARA;;GAAA;AAGA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAWF;;AARA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAWF;;AATA;EACE,6BAAA;EACA,cAAA;EAEA,+BAAA;AAWF;;AARA;EACE,cAAA;AAWF;;AATA;EACE,6BAAA;EACA,cAAA;EACA,cAAA;EACA,+BAAA;AAYF;;AAVA;EACE,aAAA;AAaF;;AAXA;EACE,sBAAA;AAcF;;AAXA;EACE,uBAAA;AAcF;;AAZA;EACE,wBAAA;AAeF","sourcesContent":[".tableip {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.tablescroll {\n  padding-top: 15px;\n}\n/* .tables{\n  margin: 0px 20px 0px 30px;\n} */\n.tablescrollunderdiv {\n  height: calc(100vh - 115px);\n  overflow: auto;\n  padding-bottom: 45px;\n  margin: 0px 20px 0px 30px;\n}\n.widthfix {\n  width: 100px;\n}\n.iconsText {\n  background-color: transparent;\n  color: #666;\n  display: flex;\n  box-shadow: none;\n  height: 20px;\n  border: none;\n  padding: 0px;\n}\n.iconsText:hover {\n  background-color: transparent;\n  box-shadow: none;\n}\n.linebutton {\n  display: flex;\n  gap: 20px;\n}\n.select {\n  width: 5px;\n}\n.circularbg {\n  background-color: red;\n}\n.rectangularbg {\n  background-color: blue;\n}\n/* .table{\n  margin-left: 10px;\n} */\n.searchbox {\n  position: relative;\n  top: -58px;\n  left: -150px;\n}\n\n.newTabButton {\n  height: 33px;\n  width: 78px;\n  cursor: pointer;\n}\n.table_container {\n  max-width: calc(100vw - 25px);\n  margin: 0 auto;\n\n  max-height: calc(100vh - 120px);\n}\n\n.stylecell {\n  font-size: 6px;\n}\n.tabtab {\n  max-width: calc(100vw - 25px);\n  margin: 0 auto;\n  overflow: auto;\n  max-height: calc(100vh - 120px);\n}\n.tabtab::-webkit-scrollbar {\n  display: none;\n}\n.tablerows {\n  background-color: blue;\n}\n\n.circularbg {\n  background-color: brown;\n}\n.rectangularbg {\n  background-color: purple;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
